import { produce } from "immer";
import { GlobalActions, resetAction } from "../../globals/store/actions";
import {
  addNewNotificationAction,
  addOnlineClientAction,
  deleteOnlineClientAction,
  SocketAction,
  socketDisconnectedAction,
} from "./actions";
import { SocketSocketAction, subscribeToChannelAction } from "./socket-actions";

export interface SocketState {
  onlineClients: string[];
  notification: string;
  disconnected: boolean;
  channelSubscription: {
    userId: string;
    conversationId: string | null;
    channel: string;
    companyId: string;
  } | null;
}

const initialState: SocketState = {
  onlineClients: [],
  notification: "",
  disconnected: false,
  channelSubscription: null,
};

export default produce(
  (
    draft: SocketState = initialState,
    action: SocketAction | SocketSocketAction | GlobalActions
  ) => {
    switch (action.type) {
      case addOnlineClientAction.type:
        if (draft.onlineClients.indexOf(action.id) === -1) {
          draft.onlineClients = [...draft.onlineClients, action.id];
        }
        return draft;
      case socketDisconnectedAction.type:
        draft.disconnected = action.disconnected;
        return draft;
      case deleteOnlineClientAction.type:
        let clients = [...draft.onlineClients];
        clients.splice(clients.indexOf(action.id), 1);
        draft.onlineClients = clients;
        return draft;
      case addNewNotificationAction.type:
        draft.notification = action.id;
        return draft;
      case subscribeToChannelAction.type:
        draft.channelSubscription = {
          userId: action.userId,
          conversationId: action.conversationId,
          channel: action.channel,
          companyId: action.companyId,
        };
        return draft;
      case resetAction.type:
        return initialState;
      default:
        return draft;
    }
  }
);
